const template = `
<div class="consent-overlay">
  <div class="consent-overlay-content">
    <h2 class="consent-heading">Cookies on the University of Edinburgh Website</h2>
    <p>
      Your consent is needed for content delivered by non-University companies.
    </p>
    <p>
      Viewing this content will result in cookies being set on your device and will result in some
      information about your visit being saved. By accepting this you agree for this information
      to be shared with these non-University companies.
    </p>
    <p class="consent-tpl-link"></p>
    <button type="button" class="consent-btn consent-btn-primary consent-btn-overlay">Accept and view</button>
  </div>
</div>
`

export default template
